import {Fragment} from 'react';
import {Tabs, TabsProps} from 'antd';
import IntlMessages from '../../../../../domain/utility/IntlMessages';
import Regions from '../regions';
import CountryInfo from '../country-info';
import {useParams} from 'react-router-dom';

const CreateCountryTabs = () => {
  const {id} = useParams();
  const itemTabs: TabsProps['items'] = id
    ? [
        {
          key: 'info',
          label: <IntlMessages id='countries.tabs.info' />,
          children: <CountryInfo />,
        },
        {
          key: 'regions',
          label: <IntlMessages id='countries.tabs.regions' />,
          children: <Regions />,
        },
      ]
    : [
        {
          key: 'info',
          label: <IntlMessages id='countries.tabs.info' />,
          children: <CountryInfo />,
        },
      ];

  return (
    <Fragment>
      <Tabs items={itemTabs} />
    </Fragment>
  );
};

export default CreateCountryTabs;
